import React, { useEffect } from 'react'
import { Box, Theme } from '@mui/material'
import { YMaps } from '@pbe/react-yandex-maps'
import { useGetUserProfileQuery } from '@/modules/user/services/userService'
import { UserTypes } from '@/types/typeUser'
import { useNavigate } from 'react-router-dom'
import { getMediaQuery } from '@/utils/getMediaQuery'

export const sxWrapper = (theme: Theme) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  ['.wrapper']: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    padding: '20px',
    flexShrink: 0,
    [getMediaQuery(theme, 'tablet')]: {
      flexDirection: 'column',
    },
  },
  ['.left']: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    [getMediaQuery(theme, 'tablet')]: {
      width: '100%',
    },
    ['.row']: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      [getMediaQuery(theme, 'tablet')]: {
        flexDirection: 'column',
      },
    },
  },
  ['.right']: {
    width: '30%',
    [getMediaQuery(theme, 'tablet')]: {
      width: '100%',
    },
  },
  ['.mapContainer']: {
    border: '1px solid #0072BC',
    flex: 1,
    minHeight: '400px',
    margin: '0 20px',
  },
  ['.footerButtons']: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 2,
    mt: 2,
    padding: '0 20px 8px 20px',
  },
})

const AddPagesWrapper = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate()
  const { data: currentUserData } = useGetUserProfileQuery('0')
  const currentUserType = currentUserData?.data.typeId
  useEffect(() => {
    if (
      currentUserType === UserTypes.user ||
      currentUserType === UserTypes.admin
    ) {
      navigate(-1)
    }
  }, [])

  return (
    <Box
      sx={{
        position: 'relative',
        padding: '16px 8px 8px 8px',
        width: '100%',
        minHeight: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(255, 255, 255, 0.83)',
      }}
    >
      <YMaps
        query={{
          load: 'package.full',
          apikey: import.meta.env.VITE_YANDEX_KEY,
        }}
      >
        {children}
      </YMaps>
    </Box>
  )
}

export default AddPagesWrapper
